import { combineReducers } from 'redux';

import welcome from './welcome';
import benefits from './benefits';
import profile from './profile';

const index = combineReducers({
  welcome,
  benefits,
  profile
});

export default index;



// WEBPACK FOOTER //
// ./src/advocate/onboarding/reducers/index.js